import styled from 'styled-components';

export const ColoredIconWrapper = styled.span`
  display: flex;
  align-items: center;
  color: ${props => props.color};
  svg {
    margin-right: 0.4em;
    path {
      fill: ${props => props.color};
    }
  }
`;
